/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { CardHeader, CardHeaderToolbar, ModalProgressBar } from "../../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";

export function PartnerQuotaEditDialogHeader({ id }) {
  const history = useHistory()
  
  const [title, setTitle] = useState("");
  // Channel Redux state
  const { partnerQuotaForEdit, actionsLoading } = useSelector(
    (state) => ({
      partnerQuotaForEdit: state.partnerQuota.partnerQuotaForEdit,
      actionsLoading: state.channels.actionsLoading,
    }),
    shallowEqual
  );

  useEffect(() => {
    let _title = id ? "" : "Edit Stock Mitra";
    if (partnerQuotaForEdit && id) {
      _title = "Edit Stock Mitra";
    }

    setTitle(_title);
    // eslint-disable-next-line
  }, [partnerQuotaForEdit, actionsLoading]);

  return (
    <>
      {actionsLoading && <ModalProgressBar variant="query" />}
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button className="btn btn-secondary" onClick={() => {
            history.goBack()
          }}>Kembali</button>
        </CardHeaderToolbar>
      </CardHeader>
    </>
  );
}
